const getBase64 = (imageFile) => {
  const reader = new window.FileReader()
  return new Promise((resolve, reject) => {
    if (!reader || !imageFile || !imageFile.type.match("image.*")) {
      reject("Please try again later")
    }
    reader.readAsDataURL(imageFile)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = (error) => {
      reject(error)
    }
  })
}

export default getBase64
